import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useAddressValidationTracking = () => {
  const track = useTracking(screenViewed)

  return {
    ctaTapped: (address_validation_result: string, cta_title: string) =>
      track.buttonTapped({
        ...ctaTapped,
        address_validation_result,
        cta_title,
      }),
  }
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'bankCardOrderSuggestedAddress',
  screen_name: 'bankCardOrderSuggestedAddress',
}

const screenViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'bankCardOrderSuggestedAddress',
  ...sharedProps,
}

const ctaTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'bankCardOrderSuggestedAddressCTA',
  ...sharedProps,
}
